import { libellesTraduits } from '../i18n/libelles';

export const ACTION_COLORS = {
    CREATE: 'green',
    READ: 'blue',
    UPDATE: 'orange',
    DELETE: 'red',
    VALIDATE: 'purple',
    EXPORT: 'cyan',
};

// Libellés traduits à la lecture : referentiels:actionsHabilitation.
export const ACTION_LABELS = libellesTraduits('referentiels:actionsHabilitation');

export const TYPE_ACCES_COLORS = {
    PROPRE: 'default',
    ORGANISME: 'geekblue',
    GLOBAL: 'gold',
};

// Libellés traduits à la lecture : referentiels:typesAcces.
export const TYPE_ACCES_LABELS = libellesTraduits('referentiels:typesAcces');